import { render, staticRenderFns } from "./wisdom.vue?vue&type=template&id=67691152&scoped=true&"
import script from "./wisdom.vue?vue&type=script&lang=js&"
export * from "./wisdom.vue?vue&type=script&lang=js&"
import style0 from "./wisdom.vue?vue&type=style&index=0&id=67691152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67691152",
  null
  
)

export default component.exports